import { Box, Text } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import { ImageUpload, type IFile } from "@/shared/upload/image-upload";
import { MultiImageUpload } from "@/shared/upload/multi-image-upload";
import { MAX_BANNERS, bannersFromImages, type MarketingState } from "./business-form-model";
import classes from "../business.module.css";

type Props = Readonly<{
  value: MarketingState;
  /** Bumped after every fetch: MultiImageUpload only reads initialData on mount, so it remounts. */
  version: number;
  businessId: string | null;
  onChange: (next: MarketingState) => void;
}>;

export function MarketingStep({ value, version, businessId, onChange }: Props) {
  const { t } = useTranslation("business");

  return (
    <Box className={classes.stack}>
      <Box className={classes.capsRow}>
        <Text component="span" className={classes.caps}>
          {t("marketing.banner")}
        </Text>
        <Text component="span" className={classes.hint}>
          {t("marketing.bannerHint")}
        </Text>
      </Box>
      <MultiImageUpload
        key={`banners-${businessId ?? "new"}-${version}`}
        initialData={value.banners}
        max={MAX_BANNERS}
        onChange={(images) => onChange({ ...value, banners: bannersFromImages(images) })}
      />

      <Text component="span" className={classes.caps}>
        {t("marketing.logo")}
      </Text>
      <Box className={classes.logoRow}>
        <ImageUpload
          size={96}
          radius="lg"
          value={value.logo}
          onChange={(file: IFile) => onChange({ ...value, logo: file.thumbnail ?? null })}
        />
        <Text component="span" className={classes.hint}>
          {t("marketing.logoHint")}
        </Text>
      </Box>
    </Box>
  );
}
